import { render, staticRenderFns } from "./stepInformationBatTh142.vue?vue&type=template&id=55a1ea9f&scoped=true"
import script from "./stepInformationBatTh142.vue?vue&type=script&lang=js"
export * from "./stepInformationBatTh142.vue?vue&type=script&lang=js"
import style0 from "./stepInformationBatTh142.vue?vue&type=style&index=0&id=55a1ea9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1ea9f",
  null
  
)

export default component.exports